<template>

<div class="container-fluid body no-gutters p-0">


  <div id="choose-plan-sectionx" class="container-fluid no-gutters ">
      <div class="container" style="width:100%">
          <div class="row" style="display:block; width:100%">
              <div class="col-12 choose-plan-col text-center"> 
                <span v-if="!$parent.isMobile" class="text-30">{{$parent.lang.chooseYourPlan}}</span>
                <embed v-if="!$parent.isMobile" class="icon-check" src="https://flxassets.s3-accelerate.amazonaws.com/2018/images/icon-check.svg" type="image/svg+xml"> 
                    <!-- <a v-on:click="$parent.suscribe()" class="btn btn-danger btn-flg triggertrial" role="button">{{$parent.lang.signUp}}</a> -->
                  <p class="lead">{{$parent.lang.signUpLead}}</p>
              </div>
          </div>
      </div>
  </div>

  <div id="choose-plan-details-section">
      <div class="container">
          <div class="row d-flex choose-plan-details-div 

          col-sm-8  col-md-8  col-lg-8  col-xl-8

           justify-content-center m-auto oferta">
               <div class="col-md-8 col-sm-8 col-xs-8 p-0">
                  <div class="row">
                    <div class="col-6 tright">
                      <button style="display: initial;" class=" cplan" v-bind:class="{ active: plan=='month'}" @click="setPlan('month')">{{$parent.lang.pricePerMonth}}</button>
                    </div>
                    <div class="col-6">
                      <button class=" cplan" v-bind:class="{ active: plan=='annual'}" @click="setPlan('annual')">{{$parent.lang.pricePerYear}}</button>
                      <span class="small_offer">{{$parent.lang.SAVE_TWOMONTHS}}</span>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div class="livecheck " v-bind:class="{ active: live}" @click="liveToggle()">
                      <span>
                      {{livePaymentPrice}}
                      </span>
                    </div>
                    <div class="">
                      <button class="aksb" aria-label="LiveChannel Detail"  @click="showLiveRac()">
                        <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="question-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-question-circle fa-w-16 fa-2x"><path fill="#fff" d="M256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28zm7.67-24h-16c-6.627 0-12-5.373-12-12v-.381c0-70.343 77.44-63.619 77.44-107.408 0-20.016-17.761-40.211-57.44-40.211-29.144 0-44.265 9.649-59.211 28.692-3.908 4.98-11.054 5.995-16.248 2.376l-13.134-9.15c-5.625-3.919-6.86-11.771-2.645-17.177C185.658 133.514 210.842 116 255.67 116c52.32 0 97.44 29.751 97.44 80.211 0 67.414-77.44 63.849-77.44 107.408V304c0 6.627-5.373 12-12 12zM256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8z" class=""></path></svg>
                      </button>
                    </div>
                  </div>
                  <div class="row live_rac justify-content-center" v-show="liveRac">
                    <div>
                      <img
                       alt="FlixLive" v-lazyload :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')" :data-src="$parent.img('/img/livebanner.png')">
                      {{$parent.lang.FLIXLATINOLIVE_RACION}}
                    </div>
                  </div>
                  <ul class="text-left chkmark" v-html="$parent.lang.REG_LIST_FEAT_X">
                  </ul>
              </div>
            <!--
              <div class="col-md-6 col-sm-6 col-xs-6 p-20">
                  <h1 class="bold-font text-center" style="padding-left: 10px;">{{$parent.lang.pricePerYear}}</h1>
                  <ul class="text-left" v-html="$parent.lang.yearList">
                  </ul>
              </div> -->
          </div>
          <div class="row justify-content-center">
            <a class="cplan" @click="$parent.suscribe(selectedPlan)">{{suscribePor}}</a>
          </div>
      </div>
  </div>


</div>
</template>


<script>




export default {
  name: 'flixBody',
  components: {
  },
  data(){ return {
      live: false,
      plan: 'month',
      liveRac: false,
      subspor: '',
      howmuch: {
        month: '3.99',
        month_live: '4.99',
        annual: '35.99',
        annual_live: '44.99'
      }
    }
  },
  created: function () {
    // this.lang = lang.es;
    // this.isIos = lang.isIos;

    
    
  },
  updated: function(){
    // this.profiling();

  },
  computed:{
    howmuchCalculated: function(){
      var hm = '';
      if(this.live){
        if (this.plan == 'month') {
          hm = this.howmuch.month_live;
        }else{
          hm = this.howmuch.annual_live;
        }
      }else{
        if (this.plan == 'month') {
          hm = this.howmuch.month;
        }else{
          hm = this.howmuch.annual;
        }
      }
      return hm;
    },
    selectedPlan: function(){
      var hm = '';
      if(this.live){
        if (this.plan == 'month') {
          hm = "monthly_live";
        }else{
          hm = "annual_live";
        }
      }else{
        if (this.plan == 'month') {
          hm = "monthly";
        }else{
          hm = "annual";
        }
      }
      return hm;
    },
    suscribePor: function(){
      // this.subspor = this.$parent.lang.SUSCRIBE_POR;

      return this.$parent.lang.SUSCRIBE_POR.replace("%%HOWMUCH%%",'$'+this.howmuchCalculated);
    },
    livePaymentPrice: function(){
      return (this.plan == "month" ? this.$parent.lang.LIVE_PAYMENT_PRICE_MONTLY : this.$parent.lang.LIVE_PAYMENT_PRICE_ANNUAL)
    }
  },
  
  methods:{
    liveToggle: function(){
      this.live = !this.live;
    },
    setPlan: function(plan){
      this.plan = plan;
    },
    showLiveRac: function(){
      this.liveRac = !this.liveRac;
    }
    

  }
  
}
</script>

